import ChipColors from './ChipColors';

export default [
  {
    text: 'Cartão',
    value: 'CardCharge',
    ...ChipColors.light,
  },
  {
    text: 'Celular',
    value: 'PhoneRecharge',
    ...ChipColors.light,
  },
  {
    text: 'Transporte',
    value: 'TransportRecharge',
    ...ChipColors.light,
  },
  {
    text: 'Loja',
    value: 'DigitalProductRecharge',
    ...ChipColors.light,
  },
  {
    text: 'Boleto',
    value: 'CashoutInvoice',
    ...ChipColors.light,
  },
];
